export enum FeatureFlag {
  GROWTH_WEBSITE_BANNER = "GROWTH_WEBSITE_BANNER",
  WEBSITE_SHOW_BOOK_BTN_ON_NAV = "WEBSITE_SHOW_BOOK_BTN_ON_NAV",
  WEB_SCHEDULING_ABANDONED_FLOW_ENABLED = "WEB_SCHEDULING_ABANDONED_FLOW_ENABLED",
  WEB_SCHEDULING_ALWAYS_SHOW_NEARBY_LOCATIONS_ENABLED = "WEB_SCHEDULING_ALWAYS_SHOW_NEARBY_LOCATIONS_ENABLED",
}
